import React from "react";
import styles from "./Categories.module.css";
import { Container } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const Categories = () => {
  const userInfo = [
    {
      id: 1,
      Head: "Natural Resource",
      Desc: "Fueling industries with reliable resources.",
      Image: "/images/Product/windwill.png",
      Title: "Aluminium, steel, copper, chrome, gold, and diamonds.",
      Title1: "Coal For energy generation and turbines.",
      Title2: "Crude oil, cooking oil, and natural gas solutions.",
    },
    {
      id: 2,
      Head: "Renewable Energy Solutions",
      Desc: "Hydrogen energy for innovative applications.",
      Image: "/images/Product/solar.png",
      Title: "Aluminium, steel, copper, chrome, gold, and diamonds.",
      Title1: "Hydrogen energy for innovative applications.",
    },
    {
      id: 3,
      Head: "Electronics",
      Desc: "Modern technology for smarter operations.",
      Image: "/images/Product/chip.png",
      Title: "Biometric devices.",
      Title1: "CCTV surveillance systems.",
      Title2: "Healthcare monitoring equipment.",
    },
    {
      id: 4,
      Head: "Consumer Goods",
      Desc: "Nourishing and enhancing everyday life.",
      Image: "/images/Product/store.png",
      Title: "Food Items: Teas, coffees, spices, and proteins.",
      Title1: "Luxury Essentials: Beauty care, body care, and premium brands.",
      Title2: "Home Décor: Stylish and functional items for modern living.",
    },
  ];
  return (
    <React.Fragment>
      <Container>
        <div className={styles.mainSection}>
          <Heading>Product Categories</Heading>
          <Paragraph>
            Our carefully curated products span multiple industries to ensure we{" "}
            <br /> deliver value where it matters most.
          </Paragraph>
        </div>

        <div className={styles.userGrid}>
          {userInfo.map((user) => (
            <div key={user.id} className={styles.userCard}>
              {" "}
              <img
                loading="lazy"
                src={user.Image}
                alt={user.name}
                className={styles.userImage}
              />
              <div className={styles.data}>
                <h6>{user.Head}</h6>
                <p>{user.Desc}</p>
              </div>
              <ul>
                {user.Title && <li>{user.Title}</li>}
                {user.Title1 && <li>{user.Title1}</li>}
                {user.Title2 && <li>{user.Title2}</li>}
              </ul>
            </div>
          ))}
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Categories;
